import type { TCliente } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class GetClienteCpfService extends HttpService {
  async execute({ cpf }: { cpf: string }) {
    return this.http.get<TCliente>(`api/v2/Cliente/obterParaProposta/${cpf}`)
  }
}
